module.exports = __webpack_public_path__ + "static/birmingham_header-1e822ccef30236bd64733dc7323d2992.jpg";